<script>
    import ProductVariations from './ProductVariations';

    export default {
        name: 'VariationsABTest',

        data() {
            return {
                useNewVersion: !!this.$scope.EXPERIMENT_VAR,
            };
        },

        components: {
            ProductVariations,
        },

        computed: {
            variationsComponent() {
                return ProductVariations;
            },
        },
    };
</script>
